import { render, staticRenderFns } from "./businessLicense.vue?vue&type=template&id=2da57777&scoped=true&"
import script from "./businessLicense.vue?vue&type=script&lang=js&"
export * from "./businessLicense.vue?vue&type=script&lang=js&"
import style0 from "./businessLicense.vue?vue&type=style&index=0&id=2da57777&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da57777",
  null
  
)

export default component.exports